import { useParams } from 'react-router-dom';
import { ArticulosFormState } from '../../../context/articulos/ArticulosFormState';
import { Form } from './form';

export const ArticulosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Articulo" : "Crear Articulo";

  return (
    <ArticulosFormState>
        <br />
        <Form title={title} />
    </ArticulosFormState>
  );
};